var modules_0b64ef5e = {"container":"_ov7xru","fullscreen":"_1x86adb","overlay":"_fxycv9","backdrop":"_6gc1p1","header":"_172u3k5","content":"_vd2kac","footer":"_4hdfh2","title":"_bet5e6","title-wrapper":"_1gdhty2","subtitle":"_15oilpr","close":"_1pjvogf","auxiliary-layer":"_1bhtwj4"};
import "../../../assets/txVmr3-t.css";

export { modules_0b64ef5e as default };
//# sourceMappingURL=Sheet.module.less.js.map
